import React from 'react';

import ReduxStoreTracker from './tracker-redux-store';

function mapStateToDL(state) {
  const {user, device, viewport} = state;

  return {
    userPref: user,
    device,
    viewport,
  };
}

class UserInfoTracker extends React.PureComponent {
  render() {
    return <ReduxStoreTracker storeKey="userInfo" reducer={mapStateToDL} />;
  }
}

export default UserInfoTracker;
